import gql from 'graphql-tag'

export const CREATE_STEP_TYPE = gql`
  mutation CreateStepType($name: String!) {
    createStepType(data: { name: $name }) {
      id
      name
    }
  }
`

export const UPDATE_STEP_TYPE = gql`
  mutation UpdateStepType($id: Int!, $name: String!) {
    updateStepType(id: $id, data: { name: $name }) {
      id
      name
    }
  }
`

export const DELETE_STEP_TYPE = gql`
  mutation DeleteStepType($id: Int!) {
    deleteStepType(id: $id) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/StepType.js